export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0c10] border-t border-white/6">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <div className="mb-5">
              <img
                src="https://99-marketing.com/wp-content/uploads/2024/03/99_logo-3.png"
                alt="99 Marketing"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-5">
              Premium website + SEO growth system for USA-based businesses. Built for how people search in 2026.
            </p>
            <a
              href="tel:8004559670"
              className="flex items-center gap-2 text-white/70 text-sm font-medium hover:text-emerald-300 transition-colors cursor-pointer"
            >
              <i className="ri-phone-fill text-emerald-400" style={{ fontSize: '14px' }}></i>
              800-455-9670
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <p className="text-white text-sm font-semibold mb-5">Quick Links</p>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: 'How It Works', href: '#how-it-works' },
                { label: 'Pricing', href: '#offer' },
                { label: 'Search Channels', href: '#search-channels' },
                { label: 'Client Reviews', href: '#testimonials' },
              ].map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white/45 text-sm hover:text-emerald-300 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Service info */}
          <div>
            <p className="text-white text-sm font-semibold mb-5">What&apos;s Included</p>
            <div className="space-y-2.5">
              {[
                'Full Website Rebuild',
                'AI + Voice Search Optimization',
                'Google + Local SEO',
                'Ongoing Performance Improvements',
                'Monthly Reporting',
              ].map((item) => (
                <div key={item} className="flex items-center gap-2">
                  <i className="ri-check-line text-emerald-400" style={{ fontSize: '13px' }}></i>
                  <span className="text-white/45 text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/6 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {currentYear} 99 Marketing. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-white/30 text-xs hover:text-white/60 transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
